<template>
<div class="stage">
  <main>
    <div class="">

      <div class="position-relative">
        <section class="story-banner">
          <stage-banner :title="title"></stage-banner>
        </section>

        <section class="story" id="story">
          <div class="container">

            <div class="story-content">

              <div>
                <b-button v-b-modal.chapterselect variant="light" size="sm" class="mb-3 py-0 px-2">
                  <span class="font-weight-bold">章節選擇</span>
                </b-button>
              </div>

              <!-- 要改的內容 -->
              <story-image :src="require(`@/assets/images/pics/第8章_4-1_賴和館1樓.jpg`)"></story-image>
              <!-- （圖片：賴和紀念館門口） -->

              <npc :npc-id="1" right>咦？賴和紀念館在這棟大樓裡嗎？</npc>
              <npc :npc-id="0">嗯，跟常見的紀念館不同，要按大樓門鈴。</npc>

              <story-image :src="require(`@/assets/images/pics/第8章_4-2_賴和館電鈴.jpg`)"></story-image>
              <!-- （圖片：門鈴） -->

              <npc :npc-id="0">門開了，走吧。</npc>
              <npc :npc-id="1" right>嗯，搭電梯到四樓！</npc>

              <story-image :src="require(`@/assets/images/pics/第8章_4-3_賴和館4樓.jpg`)"></story-image>
              <!-- （圖片：四樓照片） -->

              <label class="text-white text-center font-weight-bold">請問您擁有實體名片嗎？</label>

              <div class="row">
                <div class="col-12 col-md-6 mb-3">
                  <move-to-stage-btn link="有實體名片">有</move-to-stage-btn>
                </div>
                <div class="col-12 col-md-6 mb-3">
                  <move-to-stage-btn link="沒有實體名片">沒有</move-to-stage-btn>
                </div>
              </div>
              <!-- 要改的內容到此 -->

            </div>

          </div>
        </section>
      </div>


      <div class="top-level">
        <top-bottom-button :question="isQuestion"></top-bottom-button>

        <b-modal id="chapterselect" hide-footer title="選擇章節">
          <chapter-select :now-stage="stageId"></chapter-select>
        </b-modal>
      </div>

    </div>
  </main>
</div>
</template>

<script>
// import Cookie from '@/utilities/Cookie.js'
import StageBanner from '@/components/StageBanner.vue'
import TopBottomButton from '@/components/TopBottomButton.vue'
import ChapterSelect from '@/components/ChapterSelect.vue'
import '@/assets/css/stage.css'

export default {
  name: 'Stage8_4',
  components: {
    StageBanner,
    TopBottomButton,
    ChapterSelect,
  },
  props: {},
  data() {
    return {
      title: '第八章 - 4',
      isQuestion: false,
      stageId: 'mace',
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
